import py from 'pinyin';

export default function $py (val) {
  return py(val, {
    style: py.STYLE_NORMAL, // 设置拼音风格
    heteronym: true
  })
}